import React from "react";

export const SvgClubInfinitum = (props) => {
	return (
		<svg
			width="19"
			height="18"
			viewBox="0 0 19 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M0.84375 9C0.84375 4.21929 4.71929 0.34375 9.5 0.34375C14.2807 0.34375 18.1562 4.21929 18.1562 9C18.1562 13.7807 14.2807 17.6562 9.5 17.6562C4.71929 17.6562 0.84375 13.7807 0.84375 9Z"
				fill="url(#paint0_linear_5290_15467)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.57168 8.99969C2.57168 12.8259 5.67345 15.9277 9.49969 15.9277C13.3259 15.9277 16.4277 12.8259 16.4277 8.99969C16.4277 5.17345 13.3259 2.07168 9.49969 2.07168C5.67345 2.07168 2.57168 5.17345 2.57168 8.99969ZM9.49969 1.20605C5.19538 1.20605 1.70605 4.69538 1.70605 8.99969C1.70605 13.304 5.19538 16.7933 9.49969 16.7933C13.804 16.7933 17.2933 13.304 17.2933 8.99969C17.2933 4.69538 13.804 1.20605 9.49969 1.20605Z"
				fill="url(#paint1_linear_5290_15467)"
			/>
			<path
				d="M7.33887 7.88639L7.53448 8.44074C7.53448 8.44074 9.72441 7.07667 10.5071 6.59298C11.5397 5.69625 10.6429 4.26719 9.66487 4.27788C9.4282 4.27104 9.19426 4.32987 8.98898 4.44785C8.7837 4.56583 8.6151 4.73835 8.50187 4.94628C8.12699 5.54948 8.47461 6.41392 8.80609 6.58166C8.84949 6.5544 9.18642 6.30909 9.28433 6.24473C8.78428 5.94051 8.67631 4.94041 9.62126 4.84271C10.3658 4.81545 10.5832 5.8101 10.1647 6.15772C10.0288 6.2399 7.33887 7.88639 7.33887 7.88639Z"
				fill="url(#paint2_linear_5290_15467)"
			/>
			<path
				d="M9.9375 7.28438L10.4646 6.9747C10.4646 6.9747 12.5948 8.56143 12.8992 8.72455C13.0038 8.79093 13.1238 8.82918 13.2476 8.8356C13.3713 8.84202 13.4947 8.81639 13.6056 8.7612C13.7165 8.706 13.8114 8.6231 13.8809 8.52052C13.9504 8.41794 13.9923 8.29915 14.0024 8.17565C14.0458 7.15397 12.6547 7.18122 12.5243 7.98004C12.3124 7.83327 12.2689 7.78442 12.057 7.63766C12.3396 6.77364 13.3938 6.65413 13.9372 6.942C14.1571 7.05753 14.3372 7.2363 14.4544 7.45524C14.5716 7.67417 14.6205 7.92321 14.5947 8.1702C14.4752 9.28959 13.3665 9.72443 12.6602 9.25709C12.296 9.00697 9.9375 7.28438 9.9375 7.28438Z"
				fill="url(#paint3_linear_5290_15467)"
			/>
			<path
				d="M11.54 8.87109L12.0073 9.21892C12.0073 9.21892 10.9911 12.0284 10.9531 12.1542C10.9245 12.2653 10.9217 12.3815 10.945 12.4939C10.9682 12.6063 11.0168 12.7118 11.087 12.8025C11.1573 12.8933 11.2473 12.9667 11.3503 13.0173C11.4533 13.0679 11.5665 13.0942 11.6813 13.0943C12.6866 13.0346 12.6921 11.6108 11.6161 11.589C11.7247 11.2684 11.7519 11.2193 11.8226 11.0401C12.168 11.0884 12.4821 11.2663 12.7011 11.5378C12.9201 11.8093 13.0276 12.154 13.0017 12.5018C12.945 12.8055 12.7897 13.082 12.5597 13.2884C12.3298 13.4947 12.0382 13.6194 11.7301 13.643C10.6596 13.664 10.2792 12.6595 10.4092 12.0454C10.5183 11.7403 11.54 8.87109 11.54 8.87109Z"
				fill="url(#paint4_linear_5290_15467)"
			/>
			<path
				d="M10.1932 11.7233L10.4052 11.1152C10.4052 11.1152 7.42186 11.1207 6.98765 11.1207C5.90076 11.1695 5.60199 12.1912 5.77035 12.7999C6.4224 14.582 8.7266 13.5547 8.28106 12.0826C8.0909 12.0772 7.78102 12.0717 7.69401 12.0717C7.86782 12.5718 7.61245 13.1314 7.03105 13.1477C6.84976 13.1479 6.67505 13.0798 6.54159 12.9571C6.40814 12.8344 6.3257 12.666 6.31065 12.4854C6.2956 12.3047 6.34904 12.125 6.46036 11.9819C6.57167 11.8388 6.73273 11.7428 6.91154 11.713C7.10674 11.7184 10.1932 11.7233 10.1932 11.7233Z"
				fill="url(#paint5_linear_5290_15467)"
			/>
			<path
				d="M7.32886 10.8539H7.95386C7.95386 10.8539 7.00828 7.88131 6.95943 7.71296C6.90402 7.53467 6.81077 7.37044 6.68606 7.2315C6.56136 7.09256 6.40812 6.98217 6.23684 6.90789C6.06555 6.8336 5.88025 6.79716 5.69359 6.80106C5.50693 6.80497 5.32331 6.84912 5.15528 6.93049C4.66069 7.24017 4.34011 7.67501 4.45962 8.34886C4.59548 9.09883 5.34021 9.80518 6.38852 9.24014C6.30696 8.94661 6.27446 8.82082 6.2254 8.64239C6.1199 8.74487 5.98605 8.81328 5.84119 8.83875C5.69634 8.86422 5.54717 8.84557 5.41305 8.78523C5.27892 8.72489 5.16602 8.62564 5.08899 8.50035C5.01196 8.37506 4.97435 8.22951 4.98105 8.08259C4.9993 7.9237 5.06832 7.77494 5.17784 7.6584C5.28737 7.54185 5.43157 7.46375 5.58902 7.43568C5.74647 7.40761 5.90877 7.43108 6.05183 7.5026C6.19488 7.57412 6.31104 7.68988 6.38307 7.83267C6.44324 8.01172 7.32886 10.8539 7.32886 10.8539Z"
				fill="url(#paint6_linear_5290_15467)"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_5290_15467"
					x1="9.5"
					y1="0.34375"
					x2="9.5"
					y2="17.6562"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#0F0F0F" />
					<stop offset="0.567708" stopColor="#1D1C1C" />
					<stop offset="0.682292" stopColor="#444444" />
					<stop offset="0.760417" stopColor="#1F1D1D" />
					<stop offset="1" stopColor="#201F1F" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_5290_15467"
					x1="4.04415"
					y1="3.54414"
					x2="12.7392"
					y2="16.467"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#BD9A64" />
					<stop offset="0.46875" stopColor="#FBDE98" />
					<stop offset="1" stopColor="#BD9A64" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_5290_15467"
					x1="7.88299"
					y1="4.90185"
					x2="10.3087"
					y2="8.04297"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#BD9A64" />
					<stop offset="0.46875" stopColor="#FBDE98" />
					<stop offset="1" stopColor="#BD9A64" />
				</linearGradient>
				<linearGradient
					id="paint3_linear_5290_15467"
					x1="10.6371"
					y1="7.19789"
					x2="11.6953"
					y2="9.9754"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#BD9A64" />
					<stop offset="0.46875" stopColor="#FBDE98" />
					<stop offset="1" stopColor="#BD9A64" />
				</linearGradient>
				<linearGradient
					id="paint4_linear_5290_15467"
					x1="10.7779"
					y1="9.58693"
					x2="13.5935"
					y2="11.885"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#BD9A64" />
					<stop offset="0.46875" stopColor="#FBDE98" />
					<stop offset="1" stopColor="#BD9A64" />
				</linearGradient>
				<linearGradient
					id="paint5_linear_5290_15467"
					x1="6.42835"
					y1="11.5096"
					x2="7.47579"
					y2="14.28"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#BD9A64" />
					<stop offset="0.46875" stopColor="#FBDE98" />
					<stop offset="1" stopColor="#BD9A64" />
				</linearGradient>
				<linearGradient
					id="paint6_linear_5290_15467"
					x1="4.96246"
					y1="7.40875"
					x2="7.326"
					y2="10.4588"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#BD9A64" />
					<stop offset="0.46875" stopColor="#FBDE98" />
					<stop offset="1" stopColor="#BD9A64" />
				</linearGradient>
			</defs>
		</svg>
	);
};
